import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  REFERRALOUTCOME_TABLE,
  BOPINSTITUTION_TABLE,
  DRUGAFTERCAREPROGRAMS_TABLE,
  GANGAFFILIATIONS_TABLE,
  REFERRALSOURCE_TABLE,
                                  // BHTsINSURANCEPROVIDERS_TABLE,
} from "actions/action-constants";
/*** signed in user */
import CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS from "components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS";
import AddEditViewReferral from "./add-edit-view-referral";
// import AddEditViewReferral from './add-edit-view-referral-hooks';

class ReferralAddRoot extends Component {
  /*** signed in user */
  static contextType = CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS;
  componentDidMount() {
    /*** signed in user */
    const c_USER = this.context;
    this.props.createNewReferral();
    this.props.getPrograms(c_USER.id);
    var paramsRO = { tablename: REFERRALOUTCOME_TABLE };
    this.props.getReferralOutcomes(paramsRO);
    var paramsRS = { tablename: REFERRALSOURCE_TABLE };
    this.props.getReferralSources(paramsRS);
                                                        // var paramsBHTs = { 'tablename': BHTsINSURANCEPROVIDERS_TABLE }
                                                        //   this.props.getBHTsInsuranceProviders(paramsBHTs);
    var paramsBOPI = { tablename: BOPINSTITUTION_TABLE };
    this.props.getBOPInstitutions(paramsBOPI);
    var paramsDAP = { tablename: DRUGAFTERCAREPROGRAMS_TABLE };
    this.props.getDrugAftercarePrograms(paramsDAP);
    var paramsGA = { tablename: GANGAFFILIATIONS_TABLE };
    this.props.getGangAffiliations(paramsGA);
  }
  render() {
    return (
      <div>
        <AddEditViewReferral
          {...this.props}
          loginID={this.context.id}
          referralMode={0}
          addReferral={this.props.addReferral}
        />
      </div>
    );
  }
}
export default withRouter(ReferralAddRoot);
